export default function IconArr2(props: any) {
    return (
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector" d="M1 13L7 7L1 1" stroke="#FFBD3C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
